// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"rA-z","smallCardRow":"sA-z","largeCardRow":"tA-z","productSearchRow":"uA-z","curatedRow":"vA-z"};